(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-dmc-plan-tabs]').forEach(function (root) {
      if (root.dataset.dmcTabsReady) return;
      const tabs = Array.from(root.querySelectorAll('[data-dmc-plan-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-dmc-plan-panel]'));
      const list = root.querySelector('.dmc-plans__tabs');
      if (!list || tabs.length < 2 || tabs.length !== panels.length) return;
      root.dataset.dmcTabsReady = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      let selected = panels.findIndex(function (panel) { return panel.dataset.dmcPanelDays === '30'; });
      if (selected < 0) selected = 0;
      function render() {
        list.hidden = !mobile.matches;
        tabs.forEach(function (tab, index) {
          const active = index === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = panels[index];
          panel.hidden = mobile.matches && !active;
          if (mobile.matches) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tab.id);
            panel.tabIndex = 0;
          } else {
            panel.removeAttribute('role');
            panel.removeAttribute('aria-labelledby');
            panel.removeAttribute('tabindex');
          }
        });
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { selected = index; render(); });
        tab.addEventListener('keydown', function (event) {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); selected = next; render(); tabs[next].focus();
        });
      });
      mobile.addEventListener('change', render);
      root.addEventListener('shopify:block:select', function (event) {
        const index = panels.findIndex(function (panel) { return panel === event.target || panel.contains(event.target); });
        if (index >= 0) { selected = index; render(); }
      });
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
